<template>
  <div class="content">
    <h1>Dodawanie nowego dokumentu</h1>
    <div class="error">Obecnie niedostępne!</div>
  </div>
</template>

<script>
export default {
  name: 'add-document'
}
</script>

<style>
  .error {
    background-color: firebrick;
    padding: 8px;
    text-align: center;
    color: #fff;
  }
</style>
